import {Device} from "src/app/infrastructure/moovement-api/models/asset";

export function isBluetoothProximitySensor(device: Device) {
  return device.typeId.startsWith("BLE-GWY-");
}
